(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "../../../store";
import { downloadSearchData } from "../dataProvider";
import { selectors as appSelectors } from "../../App";
import { countryCodeSelector, hsCodeDetailsSelector } from "../state/selectors";
import SearchDetails from "../components/SearchDetails";
import useValidateUrl from "./hooks/useValidateUrl";
import useLoadHsCodeDetails from "./hooks/useLoadHsCodeDetails";
import useSetActiveChapter from "./hooks/useSetActiveChapter";
import useLanguage from "../../Translation/hooks/useLanguage";
import useQueryParams from "../../../hooks/useQueryParams";

const SearchDetailsContainer = () => {
  const {
    hsCode
  } = useParams();
  useValidateUrl({
    hsCode
  });
  const code2 = useMemo(() => hsCode.slice(0, 2), [hsCode]);
  const code4 = useMemo(() => hsCode.slice(0, 4), [hsCode]);
  const code6 = useMemo(() => hsCode.slice(0, 6), [hsCode]);
  useSetActiveChapter(code2);
  const config = useSelector(appSelectors.configSelector);
  const {
    dir,
    language
  } = useLanguage();
  const countryCode = useSelector(countryCodeSelector);
  const [{
    country
  }] = useQueryParams();
  const hsCode2Details = useSelector(state => hsCodeDetailsSelector(state, {
    hsCode: code2,
    countryCode: country || countryCode
  }));
  const hsCode4Details = useSelector(state => hsCodeDetailsSelector(state, {
    hsCode: code4,
    countryCode: country || countryCode
  }));
  const hsCode6Details = useSelector(state => hsCodeDetailsSelector(state, {
    hsCode: code6,
    countryCode: country || countryCode
  }));
  useLoadHsCodeDetails({
    hsCode: code2,
    details: hsCode2Details,
    countryCode: country || countryCode,
    language
  });
  useLoadHsCodeDetails({
    hsCode: code4,
    details: hsCode4Details,
    countryCode: country || countryCode,
    language
  });
  useLoadHsCodeDetails({
    hsCode: code6,
    details: hsCode6Details,
    countryCode: country || countryCode,
    language
  });
  const isLoading = useMemo(() => !hsCode2Details || !hsCode4Details || !hsCode6Details, [hsCode2Details, hsCode4Details, hsCode6Details]);
  const handleDownload = useCallback(value => {
    downloadSearchData(value, hsCode2Details.code, language);
  }, [hsCode2Details, language]);
  const isRtl = dir === "rtl";
  return /*#__PURE__*/React.createElement(SearchDetails, {
    isLoading: isLoading,
    hsCodeLevel2: hsCode2Details,
    hsCodeLevel4: hsCode4Details,
    hsCodeLevel6: hsCode6Details,
    searchCode: hsCode,
    onApplyCode: config && config.onApplyCode,
    onBackAction: config && config.onBackAction,
    basicUrl: config && config.basicUrl,
    colors: config.colors,
    isRtl: isRtl,
    onDownload: handleDownload
  });
};

__signature__(SearchDetailsContainer, "useParams{{ hsCode }}\nuseValidateUrl{}\nuseMemo{code2}\nuseMemo{code4}\nuseMemo{code6}\nuseSetActiveChapter{}\nuseSelector{config}\nuseLanguage{{ dir, language }}\nuseSelector{countryCode}\nuseQueryParams{[{ country }]}\nuseSelector{hsCode2Details}\nuseSelector{hsCode4Details}\nuseSelector{hsCode6Details}\nuseLoadHsCodeDetails{}\nuseLoadHsCodeDetails{}\nuseLoadHsCodeDetails{}\nuseMemo{isLoading}\nuseCallback{handleDownload}", () => [useParams, useValidateUrl, useSetActiveChapter, useSelector, useLanguage, useSelector, useQueryParams, useSelector, useSelector, useSelector, useLoadHsCodeDetails, useLoadHsCodeDetails, useLoadHsCodeDetails]);

const _default = SearchDetailsContainer;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SearchDetailsContainer, "SearchDetailsContainer", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchDetailsContainer.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchDetailsContainer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();